module.exports = __webpack_public_path__ + "img/baby-normal.179cd5e7.png";